var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-box"},[_c('div',{staticClass:"cover"},[_c('img',{attrs:{"src":require(`@/assets/${_vm.imgPath}`),"alt":{ subTitle: _vm.subTitle }}}),_c('div',{staticClass:"sub-title"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.subTitle)}})]),_c('div',{staticClass:"text-area"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }